import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Border from '@fuww/library/src/Articles/Sections/Border';
import { MoreNews } from '@fuww/library/src/Articles/Sections/MoreNews';
import MoreNewsMixedBlock from './MoreNewsMixedBlock';
import messages from '../../../../lib/messages.json';

const getOffset = (rows, index) => rows.slice(0, index).reduce(
  (offset, ComponentType) => offset + ComponentType.cardinality,
  0,
);

const MoreNewsSection = ({
  variables, notInIds, showCreatedAt, rows, skip,
}) => {
  const intl = useIntl();
  const categoryHeading = intl.formatMessage(messages.moreNews);

  return (
    <>
      <Border />
      <MoreNews
        categoryHeading={categoryHeading}
        rows={rows.map((Component, index) => (
          <Component
            variables={variables}
            notInIds={notInIds}
            showCreatedAt={showCreatedAt}
            offset={getOffset(rows, index)}
            skip={skip}
          />
        ))}
      />
    </>
  );
};

MoreNewsSection.propTypes = {
  notInIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  variables: PropTypes.shape({}),
  showCreatedAt: PropTypes.bool,
  skip: PropTypes.bool,
  rows: PropTypes.arrayOf(
    PropTypes.elementType,
  ),
};

MoreNewsSection.defaultProps = {
  variables: null,
  showCreatedAt: false,
  skip: false,
  rows: [MoreNewsMixedBlock],
};

export default MoreNewsSection;
